module.exports = __webpack_public_path__ + "AdobeStock_161673435_shaded3.5.png?98a91bc661f6f87f75e0243f38f57b7d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_161673435_shaded3.5.png
// module id = 314
// module chunks = 0